
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DCOOF",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DCOOF.vue